import { findLastIndex } from "lodash";
import { useEffect } from "react";
import {
	generatePath,
	Redirect,
	useLocation,
	useParams,
} from "react-router-dom";
import routing from "routing";
import ExamComponent from "src/components/Exam/Exam";
import ExamSkeleton from "src/components/NewComponents/Skeletons/Exam";
import { useGetExam } from "src/hooks/useExam";
import { clearTransientCache } from "src/queryClient";
import { QuestionSettingsProvider } from "src/reducers/exam";

import { FullHeightContainer } from "../../Default/FullHeightContainer";

const getLastResolvedQuestionIndex = (questions) => {
	const lastAnsweredQuestionsIndex = findLastIndex(
		questions,
		(question) => question.answer,
	);

	if (lastAnsweredQuestionsIndex === -1) {
		return 1;
	}

	return lastAnsweredQuestionsIndex + 1;
};

export function DefaultExam() {
	const { questionId } = useParams();
	const { id } = useParams();
	const { search } = useLocation();
	const { isLoading, data } = useGetExam(id);

	useEffect(() => {
		return () => {
			clearTransientCache();
		};
	}, []);

	if (isLoading) {
		return <ExamSkeleton />;
	}

	if (!questionId) {
		const questionId = getLastResolvedQuestionIndex(data.questions);
		return (
			<Redirect
				to={{
					pathname: generatePath(routing.paths.exam, { id, questionId }),
					search,
				}}
			/>
		);
	}

	return (
		<FullHeightContainer>
			<QuestionSettingsProvider>
				<ExamComponent viewOnly={data.status === "finished"} type={data.type} />
			</QuestionSettingsProvider>
		</FullHeightContainer>
	);
}
